import * as React from "react";
import intl from "react-intl-universal";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { RestfulProvider } from "restful-react";
import { SnackbarProvider } from "notistack";
import { withStyles } from "@material-ui/core";

import LocaleEnGB from "locales/en-GB";
import LocaleZhCN from "locales/zh-CN";
import { getDefaultLocale } from "utils/localStorage";
import { MuiProvider } from "MuiProvider";
import { routing } from "routing";
import { LandscapePage } from "public/LandscapePage";
import LandingPage from "public/LandingPage/LandingPage";
import { Main } from "modules/main";
import { getToken, clearDefaultTeam, clearToken } from "utils/localStorage";
import { UserProvider } from "context";

const { Urls } = routing;

const LOCALES = {
  "en-GB": LocaleEnGB,
  "zh-CN": LocaleZhCN,
};

interface IState {
  initDone: boolean;
}

// FIXME: for some reason, the font size on snackbar is very small, have to manually set to proper size
// maybe to due to material ui, but not sure
const SNACKBAAR_FONT_SIZE = "14px";

const styles = {
  success: { fontSize: SNACKBAAR_FONT_SIZE },
  error: { fontSize: SNACKBAAR_FONT_SIZE },
  warning: { fontSize: SNACKBAAR_FONT_SIZE },
  info: { fontSize: SNACKBAAR_FONT_SIZE },
};

class AppComp extends React.Component<any, IState> {
  state = { initDone: false };

  loadLocales = () => {
    intl
      .init({
        currentLocale: getDefaultLocale(),
        locales: LOCALES,
      })
      .then(() => {
        this.setState({ initDone: true });
        window.document.title = intl.get("APP_NAME");
      });
  };

  componentDidMount() {
    this.loadLocales();
  }

  handleError(err: { message: string; data: any; status?: number }) {
    if (err.status && err.status === 401) {
      clearToken();
      clearDefaultTeam();
      window.location.href = "/";
    }
  }

  injectAuthHeader = (): any => {
    const authToken = getToken();
    return { headers: { Authorization: `Token ${authToken}` } };
  };

  renderMainWrapper = () => {
    return (
      <RestfulProvider
        base="/"
        requestOptions={this.injectAuthHeader()}
        onError={this.handleError}
      >
        <UserProvider>
          <Main />
        </UserProvider>
      </RestfulProvider>
    );
  };

  render() {
    const { classes } = this.props;
    const { initDone } = this.state;
    return (
      initDone && (
        <MuiProvider>
          <SnackbarProvider
            maxSnack={3}
            classes={{
              variantSuccess: classes.success,
              variantError: classes.error,
              variantWarning: classes.warning,
              variantInfo: classes.info,
            }}
          >
            <BrowserRouter>
              <Switch>
                <Route exact path={`${Urls.ROOT}`} component={LandingPage} />
                <Route path={Urls.PLATFORM()} render={this.renderMainWrapper} />
                <Route
                  path={[
                    Urls.FORGOT_PASSWORD,
                    Urls.RESET_PASSWORD,
                    Urls.NOT_FOUND,
                    Urls.SIGN_UP,
                  ]}
                  component={LandscapePage}
                />
                <Redirect to={Urls.NOT_FOUND} />
              </Switch>
            </BrowserRouter>
          </SnackbarProvider>
        </MuiProvider>
      )
    );
  }
}

export const App = withStyles(styles)(AppComp);
